/**
 * Created by Administrator on 2018/4/26.
 */
import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);
import axios from 'axios'
export default new vuex.Store({
    state:{
        currenttype:'',
        show:false,
        loginstate:false,
        showloginform:false,
        accesstoken:'',
        username:'登录',
        uid:0,
        baseurl: 'https://www.ask2.cn/',
    } , mutations:{
        switch_dialog(state){//这里的state对应着上面这个state
    state.show = state.show?false:true;
    //你还可以在这里执行其他的操作改变state
},
loginout(state){
   var _this=this

    var mydata={
        accesstoken:window.localStorage.getItem('accesstoken')
    }
    var params = 'ajax=' + encodeURIComponent(JSON.stringify(mydata));
    axios.post(_this.state.baseurl + 'appstore/loginout', params).then(function (response) {
        window.localStorage.clear()
        _this.state.accesstoken=''
        _this.state.username='登录'
        _this.state.loginstate=false
        _this.state.uid=0


    }).catch(function (error) {
        console.log(error);
    });

}
}
})


// WEBPACK FOOTER //
// ./src/store/index.js